<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Fecha de Solicitud</label>
            <b-form-input
              type="date"
              v-model="fechaSolicitud"
              @input="filter"
            />
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Fecha Límite</label>
            <b-form-input
              type="date"
              v-model="fechaLimite"
              @input="filter"
            />
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Establecimiento Origen</label>
            <v-select
              v-model="selectedLocal"
              :options="locals"
              label="name"
              placeholder="Seleccion establecimiento"
              @input="filter"
            />
          </b-col>
          <b-col md="2" class="mb-md-0 mb-2">
            <label>Cliente</label>
            <v-select
              v-model="selectedClient"
              :options="clients"
              label="fullname"
              placeholder="Seleccionar cliente"
              @input="filter"
            />
          </b-col>

          <b-col md="2" class="mb-md-0 mb-2">
            <label>Estado</label>
            <v-select
              v-model="state"
              :options="states"
              label="name"
              placeholder="Seleccionar Estado"
              @input="filter"
            />
          </b-col>
          <b-col md="1" class="mt-2">
            <b-button
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <span class="align-middle">Borrar</span>
            </b-button>
          </b-col>
          <b-col md="1" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click.prevent="agregar"
            >
              <span class="align-middle">Agregar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import StoresService from '@/services/StoresService'
import UserService from '@/services/UserService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      fechaSolicitud: '',
      fechaLimite: '',
      state: null,
      selectedLocal: null,
      selectedClient: null,
      locals: [],
      clients: [],
      arrayFilters: [],
      states: [
        { name: 'Incompleto' },
        { name: 'Completo' },
        { name: 'Pendiente' }
      ],
    };
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  mounted() {
    this.getLocals()
    this.getClients()
  },
  methods: {
    async getLocals() {
      const url = `?limit=100&page=1&order=desc&sort=id&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await StoresService.getStores(url,this.$store)
      if (resp) {
        this.locals = resp.data.rows
      }
    },

    async getClients() {
      const resp = await UserService.getUsers('', this.$store);
      if (resp) {
        this.clients = resp.data.rows.filter(user => user.role.name === 'Cliente');
      }
    },
    filter() {
      this.arrayFilters = [];

      if (this.fechaSolicitud) {
        const startOfDay = new Date(this.fechaSolicitud);
        startOfDay.setHours(0, 0, 0, 0);
        startOfDay.setDate(startOfDay.getDate() + 1);

        const endOfDay = new Date(this.fechaSolicitud);
        endOfDay.setHours(0, 0, 0, 0);
        endOfDay.setDate(endOfDay.getDate() + 2);

        this.arrayFilters.push({
          keyContains: 'created_at',
          key: 'gte',
          value: startOfDay, 
        });

        this.arrayFilters.push({
          keyContains: 'created_at',
          key: 'lt', 
          value: endOfDay, 
        });
      }

      if (this.fechaLimite) {
        const formattedFechaLimite = new Date(this.fechaLimite);
        console.log(formattedFechaLimite)
        this.arrayFilters.push({
          keyContains: 'limitDate',
          key: 'equals',
          value: formattedFechaLimite,
        });
      }

      if (this.selectedLocal) {
        this.arrayFilters.push({
          keyContains: 'establishmentOriginId',
          key: 'equals',
          value: this.selectedLocal.id
        });
      }

      if (this.state) {
        this.arrayFilters.push({
          keyContains: 'state',
          key: 'equals',
          value: this.state.name
        });
      }

      if (this.selectedClient) {
        this.arrayFilters.push({
          keyContains: 'clientId',
          key: 'equals',
          value: this.selectedClient.id
        });
      }

      this.$parent.$parent.arrayFilters = this.arrayFilters;
      this.$parent.$parent.getData();
    },
    agregar(){
      this.$router.push({ name: 'prestamo-add' })
    },

    clean() {
      this.fechaSolicitud = '';
      this.fechaLimite = '';
      this.selectedLocal = null;
      this.selectedClient = null;
      this.state = null;
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters;
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>